import React from "react";
import { ReactComponent as Icon } from "../../../../../assets/icons/videoPlayer/pause.svg";

function Pause({ color = "var(--gold)", width = "20px", className = "", onClick = () => {} }) {
  return <Icon fill={color} width={width} height={width} className={className} onClick={onClick} />;
}

export default Pause;
